import Sevenseas from './Sevenseas.vue'
import Enig from './Enig.vue'
import Retell from './Retell.vue'
import Wordchaos from './Wordchaos.vue'
import Horerduordet from './Horerduordet.vue'
import Picturebook from './Picturebook.vue'

export { Sevenseas, Retell, Enig, Wordchaos, Horerduordet, Picturebook }
